import React from 'react'
import { useTranslation } from 'react-i18next'
import { formatDateTimeToDateTimeBR } from 'utils/date_utils'
import {
  TimelineWrap, TimelineLine, TimelineItem, TimelineDot,
  TimelineDate, TimelineCard, TimelineTitle,
} from './AssessmentDetail.styles'

const CATEGORY_COLOR = {
  creation: 'var(--vo-celeste)',
  vendor: 'var(--vo-celeste)',
  executive: 'var(--vo-warning)',
  review: 'var(--vo-success)',
  security: 'var(--vo-danger)',
}

const CheckSVG = () => (
  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="20 6 9 17 4 12" />
  </svg>
)

const CrossSVG = () => (
  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" />
  </svg>
)

const DotIcon = ({ action }) => {
  if (action === 'approved') return <CheckSVG />
  if (action === 'rejected') return <CrossSVG />
  return null
}

export const AssessmentTimeline = ({ assessment, approvalHistory }) => {
  const { t } = useTranslation(['gap-analysis'])

  if (!assessment) return null

  const events = []

  if (assessment.createdAt) {
    events.push({
      id: 'created',
      action: 'created',
      category: 'creation',
      label: t('gap-analysis:assessment.timeline.events.created'),
      timestamp: assessment.createdAt,
    })
  }

  if (assessment.emailSentAt) {
    events.push({
      id: 'email',
      action: 'email',
      category: 'vendor',
      label: t('gap-analysis:assessment.timeline.events.invitationSent'),
      timestamp: assessment.emailSentAt,
    })
  }

  if (assessment.submittedAt) {
    events.push({
      id: 'submitted',
      action: 'submitted',
      category: 'vendor',
      label: t('gap-analysis:assessment.timeline.events.vendorSubmitted'),
      timestamp: assessment.submittedAt,
    })
  }

  if (approvalHistory?.requestedAt) {
    events.push({
      id: 'exec',
      action: 'exec',
      category: 'executive',
      label: t('gap-analysis:assessment.timeline.events.execApprovalRequested'),
      timestamp: approvalHistory.requestedAt,
    })
  }

  events.sort((a, b) => new Date(a.timestamp) - new Date(b.timestamp))

  if (events.length === 0) {
    return (
      <p style={{ fontFamily: "'Lato',sans-serif", fontSize: '14px', color: 'var(--vo-slate)', margin: 0, textAlign: 'center', padding: '16px 0' }}>
        {t('gap-analysis:assessment.timeline.noEvents')}
      </p>
    )
  }

  return (
    <TimelineWrap>
      <TimelineLine />
      {events.map((entry) => (
        <TimelineItem key={entry.id}>
          <TimelineDot $color={CATEGORY_COLOR[entry.category] || 'var(--vo-slate)'}>
            <DotIcon action={entry.action} />
          </TimelineDot>
          <TimelineDate>{formatDateTimeToDateTimeBR(entry.timestamp)}</TimelineDate>
          <TimelineCard>
            <TimelineTitle>{entry.label}</TimelineTitle>
          </TimelineCard>
        </TimelineItem>
      ))}
    </TimelineWrap>
  )
}
